import { Observable } from 'rxjs';

import { User, UserCreateParams, UserOrganizationUpdateParams, UserQueryParams, UserUpdateParams } from '../models/user.model';
import { ListResponse } from '../models/utility.model';

export abstract class UserGateway {
  abstract listUsers(params: UserQueryParams): Observable<ListResponse<User>>;
  abstract createUser(params: UserCreateParams): Observable<User>;
  abstract updateUser(userId: string, params: UserUpdateParams): Observable<User>;
  abstract deleteUser(userId: string): Observable<void>;
  abstract updateUserOrganization(userId: string, params: UserOrganizationUpdateParams): Observable<User>;
}
